export const GET_ALL_CONTRIBUTOR_ROLE = 'GET_ALL_CONTRIBUTOR_ROLE';
export const GET_ALL_CONTRIBUTOR_ROLE_SUCCESS =
  'GET_ALL_CONTRIBUTOR_ROLE_SUCCESS';
export const GET_ALL_CONTRIBUTOR_ROLE_ERROR = 'GET_ALL_CONTRIBUTOR_ROLE_ERROR';
